import React from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../contexts/ProductContext';
import { useAuth } from '../contexts/AuthContext';
import { useSettings } from '../contexts/SettingsContext';
import { FaUsers, FaCalendar, FaClock, FaTruck, FaLeaf, FaShieldAlt } from 'react-icons/fa';
import CountdownTimer from '../components/CountdownTimer';

const Home = () => {
  const { getAvailableProducts } = useProducts();
  const { user } = useAuth();
  const { getNextDeliveryDate } = useSettings();
  const featuredProducts = getAvailableProducts().slice(0, 3);

  // Society pre-order specific data
  const deliveryDate = getNextDeliveryDate();

  return (
    <div>
      <section className="hero-section" style={{ minHeight: '60vh' }}>
        <div className="container">
          <h1 className="hero-title">Fresh Homemade Food</h1>
          <p className="hero-subtitle">
            Order delicious, home-cooked meals with convenient pre-order and delivery
          </p>
          
          {/* Countdown Timer */}
          <div className="bg-white bg-opacity-20 rounded p-3 mb-3 d-inline-block">
            <CountdownTimer showWarning={true} />
          </div>
          
          {user ? (
            <Link to="/products" className="btn btn-primary btn-lg">
              Browse Pre-Order Menu
            </Link>
          ) : (
            <div className="d-flex gap-3 justify-content-center">
              <Link to="/register" className="btn btn-primary btn-lg">
                Register
              </Link>
              <Link to="/login" className="btn btn-secondary btn-lg">
                Login
              </Link>
            </div>
          )}
        </div>
      </section>

      <section className="container mt-3">
        <h2 className="text-center mb-3">Featured Menu Items</h2>
        <div className="product-grid">
          {featuredProducts.map((product) => (
            <div key={product.id} className="product-card">
              {/* Pre-order badge */}
              <div className="position-absolute top-0 start-0 m-2">
                <span className="badge bg-success">Pre-Order</span>
              </div>
              
              <img
                src={product.image}
                alt={product.name}
                className="product-image"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/300x200?text=Food+Image';
                }}
              />
              <div className="product-info">
                <h3 className="product-title">{product.name}</h3>
                <p className="product-price">₹{product.price}</p>
                <p className="product-description">{product.description}</p>
                
                {/* Pre-order specific info */}
                <div className="mb-2 p-1 bg-light rounded">
                  <small className="text-secondary">
                    <FaCalendar className="me-1" />
                    Delivery: {deliveryDate.toLocaleDateString()}
                  </small>
                </div>
                
                <Link
                  to={`/product/${product.id}`}
                  className="btn btn-primary"
                >
                  View Details
                </Link>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-3">
          <Link to="/products" className="btn btn-primary btn-lg">
            View Full Menu
          </Link>
        </div>
      </section>

      <section className="container mt-3 mb-3">
        <h2 className="text-center mb-3">Why Choose Our Food?</h2>
        <div className="row">
          <div className="col-md-6 text-center mb-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="mb-3">
                  <FaCalendar className="text-accent" style={{ fontSize: '2.5rem' }} />
                </div>
                <h3>Scheduled Delivery</h3>
                <p>Know exactly when your food will arrive. All orders are delivered together on the scheduled date.</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 text-center mb-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="mb-3">
                  <FaLeaf className="text-success" style={{ fontSize: '2.5rem' }} />
                </div>
                <h3>Fresh & Quality</h3>
                <p>Fresh ingredients sourced locally and prepared with care. Quality guaranteed for every order.</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row mt-4">
          <div className="col-md-4 text-center mb-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="mb-3">
                  <FaTruck className="text-primary" style={{ fontSize: '2.5rem' }} />
                </div>
                <h3>Batch Delivery</h3>
                <p>Efficient delivery system that brings all orders at once, reducing costs and environmental impact.</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 text-center mb-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="mb-3">
                  <FaClock className="text-warning" style={{ fontSize: '2.5rem' }} />
                </div>
                <h3>Order Deadlines</h3>
                <p>Clear deadlines ensure timely processing and preparation. Plan ahead and never miss the order window.</p>
              </div>
            </div>
          </div>
          <div className="col-md-4 text-center mb-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="mb-3">
                  <FaShieldAlt className="text-success" style={{ fontSize: '2.5rem' }} />
                </div>
                <h3>Secure & Reliable</h3>
                <p>Safe payment processing and reliable order management. Your orders are handled with care.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 